<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1200" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ _detail.ConsentHeader }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <b class="green--text">{{ $t("upload.text4") }}</b>
          <div v-html="_detail.ConsentDetail"></div>
        </v-card-text>
        <v-card-text class="pt-6">
          <b class="error--text">{{ $t("upload.text5") }}</b>
          <div v-html="_detail.ConsentReject"></div>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            {{ $t("consentform.off") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_header", "_detail"],
  data: function () {
    return {};
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
  },
};
</script>
